module.exports = __webpack_public_path__ + "static/img/about_banner.e3be7f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_banner.png
// module id = k5CR
// module chunks = 1